export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            如有资源投稿、广告合作或意见反馈，欢迎通过以下方式联系
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/60 p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-lg hover:bg-background-50 transition-colors duration-200 cursor-pointer text-center"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </span>
                <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">投稿邮箱</span>
                <span className="text-xs text-foreground-500">submit@rjystv.com</span>
              </a>

              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-lg hover:bg-background-50 transition-colors duration-200 cursor-pointer text-center"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-xl text-accent-600"></i>
                </span>
                <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">官方微信</span>
                <span className="text-xs text-foreground-500">RJYS-TV</span>
              </a>

              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-lg hover:bg-background-50 transition-colors duration-200 cursor-pointer text-center"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-team-line text-xl text-secondary-600"></i>
                </span>
                <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">商务合作</span>
                <span className="text-xs text-foreground-500">bd@rjystv.com</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}